import DOMPurify from 'dompurify';

export const escapeHtml = (text: string) =>
  text
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

export const htmlToPlainText = (html: string): string => {
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return (doc.body.textContent ?? '').trim();
  } catch {
    return html;
  }
};

export const sanitizeHtml = (html: string): string => {
  try {
    return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
  } catch {
    return '';
  }
};

export const snapshotHtmlToAlignmentPoints = (html: string): string[] => {
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const lis = Array.from(doc.querySelectorAll('li'));
    const points = lis
      .map((li) => (li.textContent ?? '').trim())
      .filter((t) => !!t);
    if (points.length > 0) return points;

    const fallback = (doc.body.textContent ?? '').trim();
    return fallback ? [fallback] : [];
  } catch {
    return [];
  }
};
